module.exports = __webpack_public_path__ + "static/media/Gameplay2.751a1ac3.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Spill/static/Gameplay2.png
// module id = 187
// module chunks = 0